import { Link } from 'react-router-dom';

import { getTabIndex } from '@/Pages/Dataset/constants';
import { Button, Tooltip } from '@/design-system';
import { useAnnotationQueueSize } from '@/hooks/useSwr';
import {
  appAnnotationQueuesPath,
  appDatasetsPath,
  appOrganizationPath,
} from '@/utils/constants';

import { isCompositeScoreRule } from '../utils/convertFeedbackFormulaToRule';

export const ResourcesCell = ({
  row,
  organizationId,
  onOpenRuleLogs,
  areEvaluatorsAlignable,
}) => {
  const { data: annotationQueueSize } = useAnnotationQueueSize(
    row.alignment_annotation_queue_id
  );

  const isCompositeScore = isCompositeScoreRule(row);

  if (isCompositeScore) {
    return (
      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
        <span className="text-xs text-tertiary">—</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
      {row.session_id && (
        <div>
          <Button
            size="sm"
            variant="outlined"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onOpenRuleLogs(row);
            }}
          >
            Logs
          </Button>
        </div>
      )}
      {row.corrections_dataset_id && (
        <Tooltip
          title={
            <div className="max-w-[350px] p-2 leading-normal">
              Labeled evaluator examples. Corrections made to feedback from this
              evaluator will automatically be added to this dataset. You can
              optionally use these as few-shot examples in subsequent evaluator
              runs.{' '}
              <a
                href="https://docs.langchain.com/langsmith/audit-evaluator-scores"
                target="_blank"
                rel="external noopener noreferrer"
                className="text-blue-300 underline"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                Read the docs
              </a>
            </div>
          }
        >
          <Link
            to={`/${appOrganizationPath}/${organizationId}/${appDatasetsPath}/${
              row.corrections_dataset_id
            }?tab=${getTabIndex('examples')}`}
            target="_blank"
            onClick={(e) => e.stopPropagation()}
          >
            <Button size="sm" variant="outlined" color="secondary">
              {areEvaluatorsAlignable
                ? 'Reference Dataset'
                : 'Correction Dataset'}
            </Button>
          </Link>
        </Tooltip>
      )}
      {row.alignment_annotation_queue_id &&
        (annotationQueueSize?.size ?? 0) > 0 && (
          <Tooltip
            title={
              <div className="max-w-[350px] p-2 leading-normal">
                Example runs awaiting human annotation. After annotation, these
                examples will be used to align the evaluator.{' '}
                <a
                  href="https://docs.langchain.com/langsmith/improve-judge-evaluator-feedback"
                  target="_blank"
                  rel="external noopener noreferrer"
                  className="text-blue-300 underline"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  Read the docs
                </a>
              </div>
            }
          >
            <Link
              to={`/${appOrganizationPath}/${organizationId}/${appAnnotationQueuesPath}/${row.alignment_annotation_queue_id}`}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
            >
              <Button size="sm" variant="outlined" color="secondary">
                Annotation Queue
              </Button>
            </Link>
          </Tooltip>
        )}
    </div>
  );
};
